import { useSearchParams } from "react-router-dom";

import { baseDefinedAndNotNullNarrowing } from "@initia-digital/ts-utils";

import { PlanOverview } from "./PlanOverview";
import { PlanServices } from "./PlanServices";
import { PlanContactsAndBookings } from "./PlanContactsAndBookings";
import { SitePlansAndPermits } from "./SitePlansAndPermits";
import { HazardAssessment } from "./HazardAssessment";
import { PPEAndTools } from "./PPEAndTools";
import { ActionAPlan } from "./ActionAPlan";

import { IPlanStageProps } from "../interfaces/componentInterfaces";
import { CONFIG } from "../config/const";

const { PLAN_STEPS } = CONFIG;


export const PlanStage = (props: IPlanStageProps) => {
    // -------------------------------
    const [searchParams] = useSearchParams();
    const stage = searchParams.get('stage') ?? PLAN_STEPS[0].value;

    if (!baseDefinedAndNotNullNarrowing(stage)) {
        // --------------------------------
        return (
            <PlanOverview {...props} />
        )
    }

    switch (stage) {
        case 'services': {
            return (
                <PlanServices {...props} />
            )
        }
        case 'contactsAndBookings': {
            return (
                <PlanContactsAndBookings {...props} />
            )
        }
        case 'sitePlansAndPermits': {
            return (
                <SitePlansAndPermits {...props} />
            )
        }
        case 'hazardAssessment': {
            return (
                <HazardAssessment {...props} />
            )
        }
        case 'ppeAndTools': {
            return (
                <PPEAndTools {...props} />
            )
        }
        case 'action': {
            return (
                <ActionAPlan {...props} />
            )
        }
        case 'workbrief':
        default: {
            return (
                <PlanOverview {...props} />
            )
        }
    }
}